// VITE_VERCEL_ENV 를 Sentry environment 로 옮긴다. D-13 표와 1:1 — 표가 바뀌면 여기와 테스트가 같이 바뀐다.
// 로컬은 값이 없어 'local' 이 되고, 이 값은 sentryOptions 에서 "기본 꺼짐" 의 근거가 된다.

export type ReportingEnvironment = 'local' | 'development' | 'staging' | 'production'

export const resolveEnvironment = (vercelEnv: string | undefined): ReportingEnvironment => {
  if (vercelEnv === 'production') return 'production'
  if (vercelEnv === 'staging') return 'staging'
  if (vercelEnv === 'development' || vercelEnv === 'preview') return 'development'
  return 'local'
}
